import * as types from './mutationTypes'
import firebase from 'firebase/app'
import 'firebase/storage'
import 'firebase/functions'
import { db } from '../helpers/firebase'
import { deserializeImage } from '../helpers/storage'

const DEFAULT_TIERS = {
  'public': {
    value: 'public',
    title: 'Public'
  }
}

const _buildTiers = (tiers, commit) => {
  let newTiers = DEFAULT_TIERS

  if (tiers) {
    for (let key in tiers) {
      newTiers[key] = {
        value: key.toLowerCase(),
        title: key.toString()
      }
    }
  }

  commit(types.UPDATE_TIERS, newTiers)
}

export const fetchChannel = async ({commit, state}, callback) => {
  let channelId = state.channel_id
  let db = firebase.firestore()
  let docRef = db.collection('channels').doc(channelId)
  const doc = await docRef.get()
  let data = doc.data()
  if (!data) {
    return callback({
      err: true,
      message: `No data returned. This either isn't a channel, or there's a problem with it.`
    })
  }

  // in this case, we just made a request, so we know
  // the user exists
  let user = firebase.auth().currentUser

  let tiers = data.tiers || {}
  // Create a format tiers for selection in pages
  _buildTiers(tiers, commit)

  if (user) {
    let uid = user.uid

    if (uid == data.owner) {
      data.isOwner = true
      const pages = await docRef.collection('pages').get()

      if (pages.docs.length > 0) {
        let pageDocs = []
        pages.forEach((page) => {
          let pageData = page.data()
          pageData.id = page.id
          pageDocs.push(pageData)
        })

        const parsedPages = [];
        for (let pageData of pageDocs) {
          if (pageData.cover_image) {
            try {
              pageData = await _getImageUrl(pageData)
            } catch (e) {
              console.error('error fetching image')
            }
          }

          parsedPages.push(pageData);
        }
        data.pages = parsedPages
      }


      commit(types.UPDATE_CHANNEL, data)
      if (callback) return callback()
      return
    }
  }

  if (data.pages) {
    const pageDocs = []

    for (let page of Object.values(data.pages)) {
      if (page.cover_image) {
        try {
          page = await _getImageUrl(page)
        } catch (e) {
          console.error('error getting cover images', e)
        }
      }

      pageDocs.push(page)
    }

    data.pages = pageDocs
  }

  commit(types.UPDATE_CHANNEL, data)
  if (callback) return callback()
}

export const movePage = ({commit, state}, data) => {
  const { new_parent_id, page_id } = data
  const channel = state.channel
  const pages = channel.pages

  const ourPage = pages.find((val) => val.id === page_id)
  ourPage.parent = new_parent_id

  channel.pages = pages.slice();

  commit(types.UPDATE_CHANNEL, channel)

  const storedPage = state.page;
  storedPage.parent = new_parent_id;

  commit(types.UPDATE_PAGE, storedPage);
}

export const fetchFans = async ({commit, state}) => {
  let channelId = state.channel_id
  let db = firebase.firestore()
  let docRef = db.collection('channels').doc(channelId).collection('fans')
  let fans = await docRef.get()
  let newFans = {}

  fans.forEach((fan) => {
    const fanData = fan.data()
    newFans[fan.id] = fanData
  })

  commit(types.UPDATE_FANS, newFans)
};

const _getImageUrl = async (page) => {
  let img = await deserializeImage(page.cover_image)
  page.cover_image = img
  return page
}

const _getImageUrls = async (page) => {
  if (!page) return
  if (page.content && page.content.blocks) {
    let newBlocks = []

    for (let block of page.content.blocks) {
      if (block.type == 'image' && block.data.file && block.data.file.url) {
        block.data.file.url = await deserializeImage(block.data.file.url)
      }

      newBlocks.push(block)
    }

    page.content.blocks = newBlocks
  }

  return page;
}

export const fetchPage = ({commit, state}, callback) => {
  let docRef = db
    .collection('channels')
    .doc(state.channel_id)
    .collection('pages')
    .doc(state.page_id)
  docRef.get().then(doc => {
    _getImageUrls(doc.data()).then((newDoc) => {
      commit(types.UPDATE_PAGE, newDoc)
      if (callback && newDoc) return callback(newDoc)
      if (callback && !newDoc) return callback({
        err: true,
        content: 'No Page here'
      })
    })
  }, (err) => {
    callback({
      err: true,
      content: err
    })
  })
}

export const fetchPreview = async ({commit, state}) => {
  let page = state.channel.pages.find((page) => page.id === state.page_id)
  commit(types.UPDATE_PAGE, page)
  return page
}
